import {
  PatientLabResultControllerApi,
  UploadLabResultAbnormalFlagEnum,
  UploadLabResultDocumentFormatEnum,
} from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

interface Params {
  uuid: string;
  labDescription?: string;
  documentFormat: UploadLabResultDocumentFormatEnum;
  file: File;
  abnormalFlag?: UploadLabResultAbnormalFlagEnum;
  recordedDate?: string;
  note?: string;
  resultValue?: string;
  xTENANTID?: string;
  fileName?: string;
}

/**
 * @author Rajkumar Rathod
 */
export const useUpdateOrderResult = () =>
  useMutationWithLoading(async (params: Params) =>
    new PatientLabResultControllerApi(getConfigObject()).updatePatientLabResult(
      params?.uuid,
      params?.documentFormat,
      params?.abnormalFlag,
      params?.recordedDate,
      params?.labDescription,
      params?.note,
      params?.resultValue,
      params?.fileName,
      params?.xTENANTID,
      params?.file
    )
  );
